
define('text!templates/appMain/privilegedMain/contentManagement/cmTooltipTemplate.html',[],function () { return '<div class="cm">\n    <span class="cm-tooltip" data-bind="text: $data"></span>\n</div>';});

